import classNames from 'classnames'
import style from './tabs.module.scss'
import { Tab, Tabs } from 'react-bootstrap'
import useGetCashinCashout from 'pages/fund/financialHistory/hooks/useGetCashinCashout'
import DotsLoading from 'components/loadings/dotsLoading'
import CashinCashout from './cashinCashout'
import useGetLoans from 'pages/fund/financialHistory/hooks/useGetLoans'
import { useCallback } from 'react'
import Loans from './loans'

export default function CustomTabs() {
    const { cashinData, isLoadingCashin } = useGetCashinCashout()
    const { loans, isLoadingLoans, fetchNextPage } = useGetLoans()

    const onWatchEnd = useCallback(() => {
        fetchNextPage?.()
    }, [fetchNextPage])

    return (
        <>
            <Tabs
                defaultActiveKey="profile"
                id="fill-tab-example"
                className={classNames('mb-3', style.myTabs)}
                fill
                variant="underline"
            >
                <Tab
                    eventKey="profile"
                    title={`تراکنش ها${
                        cashinData?.result?.length
                            ? ` (${cashinData.result.length})`
                            : ''
                    }`}
                >
                    <>
                        {isLoadingCashin ? (
                            <DotsLoading />
                        ) : cashinData && cashinData?.result?.length > 0 ? (
                            <CashinCashout data={cashinData.result} />
                        ) : (
                            <p className=" text-center">
                                هنوز هیچ تراکنشی برای این عضو ثبت نشده است
                            </p>
                        )}
                    </>
                </Tab>
                <Tab
                    eventKey="home"
                    title={`وام ها (${loans?.pages[0]?.count || 0})`}
                >
                    <>
                        {isLoadingLoans ? (
                            <DotsLoading />
                        ) : loans && loans?.pages?.length > 0 ? (
                            <Loans data={loans} onWatchEnd={onWatchEnd} />
                        ) : (
                            <p className=" text-center">
                                هنوز هیچ وامی برای این این عضو ثبت نشده است
                            </p>
                        )}
                    </>
                </Tab>
            </Tabs>
        </>
    )
}
